import { Dialog } from 'primereact/dialog'
import PmrE2EProjectDetailsOrderlineModel from '../../../interfaces/pmr-e2e-project-details-orderline-model'
import { Button } from 'primereact/button'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import moment from 'moment'

type Props = {
  visible: boolean
  onHide: () => void
  orderlines: PmrE2EProjectDetailsOrderlineModel[]
}

const OrderLinesDialog = (props: Props) => {
  const header = 'Order lines included in this reassignment'
  const footer = (
    <div className="!text-center">
      <Button label="CLOSE" className="default-cancel-button" onClick={props.onHide} />
    </div>
  )

  return (
    <Dialog
      header={header}
      footer={footer}
      className="default max-w-[95dvw]"
      visible={props.visible}
      onHide={props.onHide}
    >
      <DataTable value={props.orderlines} size="small" showGridlines>
        <Column
          field="orderLineNumber"
          header="Order Line Number"
          headerClassName="center !px-4"
          className="!text-center"
        />
        <Column
          field="projectNumber"
          header="Project Number"
          headerClassName="center !px-4"
          className="!text-center"
        />
        <Column
          field="orderNumber"
          header="Order Number"
          headerClassName="center !px-4"
          className="!text-center"
        />
        <Column
          field="gmaWBProjectName"
          header="GMAWB Project"
          headerClassName="center !px-4"
          className="!text-center"
        />
        <Column field="flexProjectName" header="FLEX Project" headerClassName="center !px-4" />
        <Column
          field="orderLineEcd"
          header="Order Line ECD"
          body={orderline =>
            orderline.orderLineECD ? moment(orderline.orderLineECD).format('DD MMM YYYY') : ''
          }
          className="!text-center"
        />
      </DataTable>
    </Dialog>
  )
}

export default OrderLinesDialog
